import React from 'react';
import { Menu, Sidebar } from 'semantic-ui-react';
import './POSSidebar.less';

export interface Props {
  title?: React.ReactNode;
  sidebarContent?: React.ReactNode;
  inverted?: boolean;
  visible?: boolean;
  direction?: 'left' | 'right' | 'top' | 'bottom';
  animation?: 'overlay' | 'push' | 'scale down';
  width?: 'very thin' | 'thin' | 'wide' | 'very wide';
  onSetVisibility?: (val: boolean) => void;
}

export const POSSidebar = ({
  title,
  sidebarContent,
  inverted,
  visible,
  direction,
  animation,
  width,
  onSetVisibility,
}: Props) => {
  return (
    <Sidebar
      as={Menu}
      animation={animation}
      direction={direction}
      icon="labeled"
      inverted={inverted}
      onHide={() => onSetVisibility && onSetVisibility(false)}
      vertical
      visible={visible}
      width={width}
    >
      {title}
      {sidebarContent}
    </Sidebar>
  );
};
